/**
 * @description Add to Cart Button widget
 * @param ProcessButton Base widget for extending
 * @returns Add to Cart Button class
 */
function AddToCartButtonClassCreator(ProcessButton: import('widgets/global/ProcessButton').TProcessButton) {
    class AddToCartButton extends ProcessButton {
        prefs() {
            return {
                isOutOfStock: false,
                classDisabledLook: 'm-like-disabled',
                ...super.prefs()
            };
        }

        /**
         * @description Widget initialization logic
         */
        init() {
            super.init();

            if (this.prefs().isOutOfStock) {
                this.disable();
            }
        }

        disable(): this {
            this.ref('self').addClass(this.prefs().classDisabledLook);

            return this;
        }

        enable(): this {
            this.ref('self').removeClass(this.prefs().classDisabledLook);

            return this;
        }
    }

    return AddToCartButton;
}

export type TAddToCartButton = ReturnType<typeof AddToCartButtonClassCreator>;

export type TAddToCartButtonInstance = InstanceType<TAddToCartButton>;

export default AddToCartButtonClassCreator;
